import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/edit-:dbId-:storyId-:categoryId-:entityId',
    name: 'EditEntity',
    component: () => import('../views/EditPage.vue')
  },
  {
    path: '/edit-:dbId-:storyId-:categoryId',
    name: 'EditCategory',
    component: () => import('../views/EditPage.vue')
  },
  {
    path: '/edit-:dbId-:storyId',
    name: 'EditStory',
    component: () => import('../views/EditPage.vue')
  },
  {
    path: '/edit',
    name: 'Edit',
    component: () => import('../views/EditPage.vue')
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

declare const gtag: any, cordova: any;
router.afterEach((to, from) => {
  if (typeof(cordova) === 'undefined' && typeof(gtag) !== 'undefined') {
    gtag('config', 'UA-174960576-1', {'page_path': to.path});
  }
  if ((window as any).analytics) {
    (window as any).analytics.logEvent('select_content', {
      content_type: 'html',
      content_id: to.path.replace('/', ''),
      items: [{ name: to.path }]
    })
  }
})

export default router;
